import {NavButton} from "../app/hungryscan/navigation/NavButton";
import {CODE_QR, STATS, USERS} from "../utils/viewsConstants";
import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useSwitchView} from "./useSwitchView";
import {Tooltip} from "../app/hungryscan/cms/Tooltip";
import {StatsIcon} from "../app/icons/StatsIcon";
import {QrCodeIcon} from "../app/icons/QrCodeIcon";
import {UsersIcon} from "../app/icons/UsersIcon";
import {useClearDashboardState} from "./useClearDashboardState";

export const useDashboardNavElements = ({type}) => {
    const {t} = useTranslation();
    const {currentView} = useSelector(state => state.globalParams.globalParams);
    const clearDashboardState = useClearDashboardState();
    const handleSwitchView = useSwitchView({clearStateHandler: clearDashboardState})
    const isBeta = String(process.env.REACT_APP_IS_BETA).toLowerCase() === 'true';

    if (type === 'expanded') {
        return [
            <NavButton key={STATS}
                       isActive={currentView === STATS}
                       name={t('statistics')}
                       icon={<StatsIcon active={currentView === STATS}/>}
                       onClick={() => handleSwitchView(STATS)}/>,
            <NavButton key={CODE_QR}
                       isActive={currentView === CODE_QR}
                       name={t('qrCode')}
                       icon={<QrCodeIcon active={currentView === CODE_QR}/>}
                       onClick={() => handleSwitchView(CODE_QR)}/>,
            <NavButton key={USERS}
                       id={'users'}
                       isActive={currentView === USERS}
                       name={t('users')}
                       icon={<UsersIcon isLocked={isBeta} active={currentView === USERS}/>}
                       isLocked={true}
                       onClick={() => {
                           if (isBeta) return;
                           handleSwitchView(USERS);
                       }}/>
        ];
    } else if (type === 'collapsed') {
        return [
            (<div onClick={() => handleSwitchView(STATS)} key={STATS}>
                <Tooltip content={t('statistics')} topOffset={-20}>
                    <StatsIcon collapsed={true} active={currentView === STATS}/>
                </Tooltip>
            </div>),
            (<div onClick={() => handleSwitchView(CODE_QR)} key={CODE_QR}>
                <Tooltip content={t('qrCode')} topOffset={-20}>
                    <QrCodeIcon collapsed={true} active={currentView === CODE_QR}/>
                </Tooltip>
            </div>),
            (<div onClick={() => {
                if (isBeta) return;
                handleSwitchView(USERS);
            }} key={USERS}>
                <Tooltip content={isBeta ? t('unavailableInBeta') : t('users')}
                         topOffset={-20}
                         style={isBeta ? {cursor: 'not-allowed'} : {}}>
                    <UsersIcon collapsed={true} isLocked={isBeta} active={currentView === USERS}/>
                </Tooltip>
            </div>)
        ];
    }
}